/* eslint-disable react/no-unknown-property */
import React, { useRef, useState } from "react";

import PropTypes from "prop-types";
import WorkShiftLogModal from "./work_shift_log_modal";

const WorkShiftLogButton = (props) => {
  const { show_popup: showPopup, work_shift_log: workShiftLog } = props;
  const [showModal, setShowModal] = useState(showPopup);
  const triggerRef = useRef(null);

  const closeModal = () => {
    setShowModal(false);
    window.requestAnimationFrame(() => triggerRef.current?.focus());
  };

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        explorator_test_id="work_shift_log_button"
        className={`work-shift-log-button ccw-button ${workShiftLog.status}`}
        aria-haspopup="dialog"
        aria-expanded={showModal}
        aria-controls="work-shift-log-dialog"
        aria-label={workShiftLog.status === "submitted" ? "Clocked in" : "Clock in"}
        onClick={() => setShowModal(true)}
      >
        {workShiftLog.status === "submitted" ? (
          <i className="fas fa-check-circle" aria-hidden="true"></i>
        ) : (
          <i className="fas fa-regular fa-clock" aria-hidden="true"></i>
        )}
        <span className="work-shift-log-button__label">
          {workShiftLog.status === "submitted" ? "Clocked in" : "Clock in"}
        </span>
      </button>
      {showModal && <WorkShiftLogModal workShiftLog={workShiftLog} onClose={closeModal} />}
    </>
  );
};

WorkShiftLogButton.propTypes = {
  show_popup: PropTypes.bool.isRequired,
  work_shift_log: PropTypes.object.isRequired
};

export default WorkShiftLogButton;
